import { useCallback } from "react";
import Cardsimple from "../../../cards/Cardsimple";
import LoaderEquipment from "../../../loaders/LoaderEquipment";

const OtmTabla = ({ codigo, data, cardStyle = "card-primary", titulo = "OTMs", selectedOtm, setSelectedOtm }) => {
    const handleScrollToOtm = useCallback((otmId) => {
        const target = document.getElementById(`otm-${otmId}`);
        if (target) {
            const navbarHeight = document.querySelector(".navbar")?.offsetHeight || 70;
            const elementPosition = target.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - navbarHeight - 50;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });

            setSelectedOtm(otmId);
        }
    }, [setSelectedOtm]);

    return (
        <div className="sticky-top d-print-none" style={{ top: "70px" }}>
            <style>
                {`
                    .otm-table tbody tr,
                    .otm-table tbody tr td {
                        cursor: pointer;
                    }

                    .otm-table thead th {
                        position: sticky;
                        top: 57px; /* altura fija de la navbar */
                        z-index: 2;
                        background: #fff;
                    }
                `}
            </style>

            <Cardsimple
                style={`${cardStyle}`}
                header={<div className="text-center text-bold">{titulo}</div>}
                condensed
            >
                <div style={{ maxHeight: "calc(100vh - 130px)", overflowY: "auto" }}>
                    {!data ? (
                        <LoaderEquipment />
                    ) : (
                        <table className="table table-sm table-hover small text-center table-head-fixed text-nowrap m-0 otm-table">
                            <thead>
                                <tr>
                                    <th className="col-2 p-0 align-middle">N°</th>
                                    <th className="col-3">Fecha</th>
                                    <th className="col-4">Tipo</th>
                                    <th className="col-3 p-0 align-middle">Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((otm) => (
                                    <tr
                                        key={otm.otm}
                                        id={`row-${otm.otm}`}
                                        className={selectedOtm === otm.otm ? "table-warning" : ""}
                                        onClick={() => handleScrollToOtm(otm.otm)}
                                    >
                                        <td className="p-0 align-middle text-bold">
                                            {otm.otm.split("-")[0]}
                                        </td>
                                        <td>{otm.fechaFin}</td>
                                        <td>{otm.tipoManto}</td>
                                        <td className="p-0 align-middle">
                                            <span className={`badge badge-${otm.estadoCss}`}>
                                                {otm.estadoFinAbr}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </Cardsimple>
        </div>
    );
};

export default OtmTabla;
